var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconErrorConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.9651C0 34.0962 9.83477 43.9302 21.9651 43.9302C34.0955 43.9302 43.9302 34.0962 43.9302 21.9651C43.9302 9.83541 34.0948 0 21.9651 0C9.83541 0 0 9.83541 0 21.9651ZM21.9651 40.9302C11.4916 40.9302 3 32.4393 3 21.9651C3 11.4923 11.4923 3 21.9651 3C32.438 3 40.9302 11.4923 40.9302 21.9651C40.9302 32.4393 32.4387 40.9302 21.9651 40.9302ZM14.3721 29.6242C13.8727 29.1248 13.8825 28.2728 14.3624 27.7929L20.1503 22.0049L14.3624 16.2072C13.8825 15.7371 13.8727 14.8753 14.3721 14.3758C14.8716 13.8666 15.7334 13.8862 16.2035 14.366L22.0012 20.154L27.7891 14.366C28.2788 13.8764 29.121 13.8764 29.6204 14.3758C30.1298 14.8753 30.12 15.7175 29.6303 16.2072L23.8424 22.0049L29.6303 27.7929C30.12 28.2825 30.12 29.1149 29.6204 29.6242C29.121 30.1236 28.2788 30.1236 27.7891 29.634L22.0012 23.8461L16.2035 29.6439C15.7334 30.1139 14.8814 30.1236 14.3721 29.6242Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorConfirm);
export default __webpack_public_path__ + "static/media/iconErrorConfirm.1edef596.svg";
export { ForwardRef as ReactComponent };